'use client';
import React, { FunctionComponent, useMemo } from 'react';
import { Breadcrumbs } from '../../../../components/Breadcrumbs';
import styles from './styles.module.scss';
import { Address, Category } from '@shared/types';
import { getPageBreadcrumbs, PageBreadcrumb, PageBreadcrumbList } from './getPageBreadcrumbs';
import Link from 'next/link';
import { useCoursesLink } from '../../../../hooks/useCoursesLink';
import { BackButton } from './BackButton';

type CoursePageBreadcrumbsProps = {
    address: Address | null;
    primaryCategory: Category | null;
};

export const CoursePageBreadcrumbs: FunctionComponent<CoursePageBreadcrumbsProps> = ({
    address,
    primaryCategory,
}) => {
    const coursesLink: string | null = useCoursesLink();
    const pageBreadcrumbs: PageBreadcrumbList | null = useMemo(() => {
        if (!coursesLink) {
            return null;
        }
        return getPageBreadcrumbs(address, coursesLink, primaryCategory);
    }, [address, coursesLink, primaryCategory]);

    if (!coursesLink || !pageBreadcrumbs) {
        return (
            <div className={styles.backButton}>
                <BackButton />
            </div>
        );
    }

    if (!address && !primaryCategory) {
        return null;
    }

    return (
        <div className={styles.container}>
            <Breadcrumbs variant="page" className={styles.coursePageBreadcrumbsList}>
                {Object.values(pageBreadcrumbs).map(
                    (pageBreadcrumb: PageBreadcrumb, index: number) => {
                        return (
                            <Link
                                itemProp="item"
                                href={pageBreadcrumb.url}
                                key={pageBreadcrumb.key}
                            >
                                <span itemProp="name">{pageBreadcrumb.label}</span>
                                <meta itemProp="position" content={`${index + 1}`} />
                            </Link>
                        );
                    }
                )}
            </Breadcrumbs>
        </div>
    );
};
